<template>
    <div>
        <!-- 多机构采购 -->
        <div class="simple-row">
            <div class="left">
                <a class="swb-btn swb-btn-small" @click="selectMerchtComList()">选择购置部门</a>
                <a class="swb-btn swb-btn-small " v-if="purchType == 1 || purchType == 3"
                   @click="selectGoodsListForBatch()">批量选择商品</a>
                <a class="swb-btn swb-btn-small " v-if="purchType == 2 || purchType == 3"
                   @click="selectServcListForBatch()">批量选择服务</a>
                <a class="swb-btn swb-btn-small " @click="generalImport">导入</a>
            </div>
        </div>
        <div v-for="(merchantCom, comIndex) in merchantComList">
            <div class="content-caption dashed">
                <span>{{ merchantCom.name }}</span>
            </div>
            <div v-show="purchType == 1 || purchType == 3">
                <div class="content-caption second">
                    <span>请购商品</span>
                    <span class="swb-btn swb-btn-link fr" v-if="merchantComList.length > 1"
                          @click="removeMerchantCom(comIndex)">移除</span>
                </div>
                <div class="simple-row">
                    <div class="left">
                        <a class="swb-btn swb-btn-small" @click="showGoodsListDlg(merchantCom, comIndex)">添加商品</a>
                    </div>
                    <div class="right">
                        <span class="mr10"
                              v-if="!lowCostFlag">含税总金额(元)：{{ parseFloat(merchantCom.wtxAmount || 0).toFixed(2) }}</span>
                        <span v-if="!lowCostFlag">包含组装件总数：{{ merchantCom.totalAsmblAccSetCount || 0 }}</span>
                    </div>
                </div>
                <el-form :model="merchantCom" ref="goodsItemList" class="demo-ruleForm">
                    <div class="table-layout">
                        <div class="table-layout" style="overflow-x: auto">
                            <table class="custom-tbl">
                                <thead class="head">
                                <tr class="row">
                                    <th width="60">序号</th>
                                    <th width="180" style="text-align: left" v-if="showAssetInfo">资产定义编码</th>
                                    <th width="180" style="text-align: left" v-if="showAssetInfo">资产描述全称</th>
                                    <th width="120" style="text-align: left" v-if="showAssetInfo">型号</th>
                                    <th width="120" style="text-align: left" v-if="showAssetInfo">规格</th>
                                    <th width="120" style="text-align: left" v-if="showAssetInfo">品牌</th>
                                    <th width="180" style="text-align: left">名称</th>
                                    <th width="120" style="text-align: left">分类名称</th>
                                    <th width="120" style="text-align: left" v-if="!showAssetInfo">品牌名称</th>
                                    <th width="120" style="text-align: left" v-if="!showAssetInfo">型号</th>
                                    <th width="120" style="text-align: left" v-if="!showAssetInfo">规格</th>
                                    <th width="60">单位</th>
                                    <th width="180" style="text-align: left">供应商</th>
                                    <th width="180" style="text-align: left">供方公司</th>
                                    <th width="80" v-if="!lowCostFlag && !onlyForAsmblAcc">仅组装件</th>
                                    <th width="80">采购模式</th>
                                    <th width="80">是否定制</th>
                                    <th width="110" style="text-align: right">含税价(元)</th>
                                    <th width="110" style="text-align: right">含税小计(元)</th>
                                    <th width="90" style="text-align: right">税率（%）</th>
                                    <th width="110" style="text-align: right">未税价(元)</th>
                                    <th width="110" style="text-align: right">包含组装件数量</th>
                                    <th width="100" style="text-align: right">申请数量</th>
                                    <th width="100" style="text-align: left">提示信息</th>
                                    <th width="180" style="text-align: left">操作</th>
                                </tr>
                                </thead>
                                <tbody class="body" v-for="(goodsItem, index) in merchantCom.goodsItemList">
                                <tr class="row">
                                    <td :rowspan="goodsItem.itemList.length + 1">
                                        <span>{{ index + 1 }}</span>
                                    </td>
                                    <td style="text-align: left" v-if="showAssetInfo">
                                        <span>{{ goodsItem.assetDefNo || '' }}</span>
                                    </td>
                                    <td style="text-align: left" v-if="showAssetInfo">
                                        <span>{{ goodsItem.devcTitle || '' }}</span>
                                    </td>
                                    <td style="text-align: left" v-if="showAssetInfo">
                                        <span>{{ goodsItem.devcModel || '' }}</span>
                                    </td>
                                    <td style="text-align: left" v-if="showAssetInfo">
                                        <span>{{ goodsItem.devcFixedSpec || '' }}</span>
                                    </td>
                                    <td style="text-align: left" v-if="showAssetInfo">
                                        <span>{{ goodsItem.devcBrandName || '' }}</span>
                                    </td>

                                    <td style="text-align: left">
                                        <span v-if="showAssetInfo">{{ goodsItem.devcName || '' }}</span>
                                        <span v-else>{{ goodsItem.name || '' }}</span>
                                    </td>
                                    <td style="text-align: left">
                                        <span v-if="showAssetInfo">{{ goodsItem.devcCatName || '' }}</span>
                                        <span v-else>{{ goodsItem.goodsCatName || '' }}</span>
                                    </td>
                                    <td style="text-align: left" v-if="!showAssetInfo">
                                        <span>{{ goodsItem.goodsBrandName || '' }}</span>
                                    </td>
                                    <td style="text-align: left" v-if="!showAssetInfo">
                                        <span>{{ goodsItem.model || '' }}</span>
                                    </td>
                                    <td style="text-align: left" v-if="!showAssetInfo">
                                        <span>{{ goodsItem.fixedSpec || '' }}</span>
                                    </td>
                                    <td>
                                        <span v-if="showAssetInfo">{{ goodsItem.devcUnit || '' }}</span>
                                        <span v-else>{{ goodsItem.unit || '' }}</span>
                                    </td>
                                    <td style="text-align: left">
                                        <span>{{ goodsItem.vendorName || '' }}</span>
                                    </td>
                                    <td style="text-align: left">
                                        <span>{{ goodsItem.vendorRealComName || '' }}</span>
                                    </td>
                                    <td v-if="!lowCostFlag && !onlyForAsmblAcc">
                                    <span>
                                        <input type="checkbox" :disabled="onlyForAsmblAcc || goodsItem.deviceId == -1"
                                               v-model="goodsItem.onlyForAsmblAcc"
                                               @change="onlyForAsmblAccChange(merchantCom, comIndex, index,goodsItem.onlyForAsmblAcc)"/>
                                    </span>
                                    </td>
                                    <td>
                                    <span v-if="goodsItem.onlyForAsmblAcc && audoAuditorFlag">
                                        <el-select v-model="goodsItem.centBuyMode" placeholder="请选择"
                                                   @change="selectCentBuyMode(merchantCom, comIndex, index)">
                                            <el-option v-for="item in centBuyModeList" :key="item.value"
                                                       :label="item.text" :value="item.value"></el-option>
                                        </el-select>
                                    </span>
                                        <span v-else>
                                        <span v-if="goodsItem.centBuyMode">集采</span>
                                        <span v-else>自采</span>
                                    </span>
                                    </td>
                                    <td>
                                        <span>{{ goodsItem.customized ? '是' : '否' }}</span>
                                        <!--<input type="checkbox" :disabled="!goodsItem.oldCustomized" v-model="goodsItem.customized" @change="changeCustomized(merchantCom, comIndex, index)"/>-->
                                    </td>
                                    <td style="text-align: right">
                                        <template v-if="!goodsItem.customized">
                                            <span v-if="goodsItem.price != null">{{ goodsItem.price.toFixed(2) }}</span>
                                            <span v-else>0.00</span>
                                        </template>
                                        <template v-else>
                                            <el-form-item :prop="'goodsItemList.' + index + '.price'">
                                                <el-input type="number" v-model="goodsItem.price"
                                                          @change="changeGoodsPrice(merchantCom, comIndex, index, goodsItem.price, true)"></el-input>
                                            </el-form-item>
                                        </template>
                                    </td>
                                    <td style="text-align: right">
                                        <span
                                            v-if="goodsItem.wtxAmount != null">{{ parseFloat(goodsItem.wtxAmount).toFixed(2) }}</span>
                                        <span v-else>0.00</span>
                                    </td>
                                    <td style="text-align: right">
                                        <span v-if="goodsItem.taxRate != null">{{ goodsItem.taxRate.toFixed(2) }}</span>
                                        <span v-else>0.00</span>
                                    </td>
                                    <td style="text-align: right">
                                        <template v-if="!goodsItem.customized">
                                            <span
                                                v-if="goodsItem.ntxPrice != null">{{ goodsItem.ntxPrice.toFixed(2) }}</span>
                                            <span v-else>0.00</span>
                                        </template>
                                        <template v-else>
                                            <el-form-item :prop="'goodsItemList.' + index + '.ntxPrice'">
                                                <el-input type="number" disabled v-model="goodsItem.ntxPrice"
                                                          @change="changeGoodsPrice(merchantCom, comIndex, index, goodsItem.price, false)"></el-input>
                                            </el-form-item>
                                        </template>
                                    </td>
                                    <td style="text-align: right">
                                        <span>{{ goodsItem.asmblAccSetCount || 0 }}</span>
                                    </td>
                                    <td style="text-align: right">
                                        <el-form-item :prop="'goodsItemList.' + index + '.quantity'">
                                            <el-input type="text"
                                                      :disabled="goodsItem.onlyForAsmblAcc || goodsItem.customized"
                                                      v-model.number="goodsItem.quantity"
                                                      @change="goodsQuantity(merchantCom, comIndex, index,goodsItem.quantity)"></el-input>
                                        </el-form-item>
                                    </td>
                                    <td>
                                        <span v-if="goodsItem.message != null" class="font-red"
                                              :title="goodsItem.message">{{ goodsItem.message }}</span>
                                        <span v-else></span>
                                    </td>
                                    <td style="text-align: left">
                                        <a class="swb-btn-link"
                                           @click="removeGoods(merchantCom, index, comIndex)">移除</a>
                                        <a class="swb-btn-link" v-if="goodsItem.skuId == -1 && goodsItem.deviceId != -1"
                                           @click="addAdoptedGoods(merchantCom, index, comIndex)">关联供方商品</a>
                                        <a class="swb-btn-link" v-if="goodsItem.message != null"
                                           @click="showGoodsListDlg(merchantCom, comIndex, index)">选择商品</a>
                                        <a class="swb-btn-link" v-if="!lowCostFlag && goodsItem.deviceId != -1"
                                           @click="addAsmblAcc(merchantCom, comIndex, index)">添加组装件</a>
                                        <a class="swb-btn-link" v-if="!lowCostFlag && goodsItem.deviceId == -1"
                                           @click="addAsmblAccForVirtual(merchantCom, comIndex, index)">添加组装件</a>
                                    </td>
                                </tr>
                                <tr class="row" v-for="(asmblAccItem, itemIndex) in goodsItem.itemList">
                                    <td style="text-align: left" v-if="showAssetInfo">
                                        <span>{{ asmblAccItem.accDefNo || '' }}</span>
                                    </td>
                                    <td style="text-align: left" v-if="showAssetInfo">
                                        <span>{{ asmblAccItem.devcTitle || '' }}</span>
                                    </td>
                                    <td style="text-align: left" v-if="showAssetInfo">
                                        <span>{{ asmblAccItem.devcModel || '' }}</span>
                                    </td>
                                    <td style="text-align: left" v-if="showAssetInfo">
                                        <span>{{ asmblAccItem.devcFixedSpec || '' }}</span>
                                    </td>
                                    <td style="text-align: left" v-if="showAssetInfo">
                                        <span>{{ asmblAccItem.devcBrandName || '' }}</span>
                                    </td>

                                    <td style="text-align: left">
                                        <span v-if="showAssetInfo">{{ asmblAccItem.devcName || '' }}</span>
                                        <span v-else>{{ asmblAccItem.name || '' }}</span>
                                    </td>
                                    <td style="text-align: left">
                                        <span v-if="showAssetInfo">{{ asmblAccItem.devcCatName || '' }}</span>
                                        <span v-else>{{ asmblAccItem.goodsCatName || '' }}</span>
                                    </td>
                                    <td style="text-align: left" v-if="!showAssetInfo">
                                        <span>{{ asmblAccItem.goodsBrandName || '' }}</span>
                                    </td>
                                    <td style="text-align: left" v-if="!showAssetInfo">
                                        <span>{{ asmblAccItem.model || '' }}</span>
                                    </td>
                                    <td style="text-align: left" v-if="!showAssetInfo">
                                        <span>{{ asmblAccItem.fixedSpec || '' }}</span>
                                    </td>
                                    <td>
                                        <span v-if="showAssetInfo">{{ asmblAccItem.devcUnit || '' }}</span>
                                        <span v-else>{{ asmblAccItem.unit || '' }}</span>
                                    </td>
                                    <td style="text-align: left">
                                        <span>{{ asmblAccItem.vendorName || '' }}</span>
                                    </td>
                                    <td style="text-align: left">
                                        <span>{{ asmblAccItem.vendorRealComName || '' }}</span>
                                    </td>
                                    <td v-if="!lowCostFlag && !onlyForAsmblAcc">
                                        <span></span>
                                    </td>
                                    <td>
                                        <span></span>
                                    </td>
                                    <td>
                                        <span></span>
                                    </td>
                                    <td style="text-align: right">
                                        <span
                                            v-if="asmblAccItem.price != null">{{ asmblAccItem.price.toFixed(2) }}</span>
                                        <span v-else>0.00</span>
                                    </td>
                                    <td style="text-align: right">
                                        <span
                                            v-if="asmblAccItem.wtxAmount != null">{{ parseFloat(asmblAccItem.wtxAmount).toFixed(2) }}</span>
                                        <span v-else>0.00</span>
                                    </td>
                                    <td style="text-align: right">
                                        <span
                                            v-if="asmblAccItem.taxRate != null">{{ asmblAccItem.taxRate.toFixed(2) }}</span>
                                        <span v-else>0.00</span>
                                    </td>
                                    <td style="text-align: right">
                                        <span
                                            v-if="asmblAccItem.ntxPrice != null">{{ asmblAccItem.ntxPrice.toFixed(2) }}</span>
                                        <span v-else>0.00</span>
                                    </td>
                                    <td></td>
                                    <td style="text-align: right">
                                        <el-form-item
                                            :prop="'goodsItemList.' + index + '.itemList.'+ itemIndex+'.quantity'"
                                            :rules="{validator: validateQuantity, trigger: 'blur'}">
                                            <el-input type="text" v-model.number="asmblAccItem.quantity"
                                                      @change="accQuantity(merchantCom, comIndex, index, itemIndex)"></el-input>
                                        </el-form-item>
                                    </td>
                                    <td></td>
                                    <td style="text-align: left">
                                        <a class="swb-btn-link"
                                           @click="removeAccGoods(merchantCom, comIndex, itemIndex, index)">移除</a>
                                        <a class="swb-btn-link"
                                           v-if="asmblAccItem.skuId == null || asmblAccItem.skuId == -1"
                                           @click="addAccSku(merchantCom, comIndex, itemIndex,index)">生成入选商品</a>
                                        <a class="swb-btn-link"
                                           @click="selectAdoptedGoods(merchantCom, comIndex, itemIndex,index)">关联入选商品</a>
                                    </td>
                                </tr>
                                </tbody>
                                <tbody class="body"
                                       v-if="merchantCom.goodsItemList == null || merchantCom.goodsItemList.length <= 0">
                                <tr class="row">
                                    <td colspan="16" style="text-align: center; line-height: 40px;">
                                        <span>暂无数据...</span>
                                    </td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </el-form>
            </div>
            <div v-show="purchType == 2 || purchType == 3">
                <div class="content-caption second">
                    <span>请购服务</span>
                </div>
                <div class="simple-row">
                    <div class="left">
                        <a class="swb-btn swb-btn-small" @click="showServcListDlg(merchantCom, comIndex)">添加服务</a>
                    </div>
                </div>
                <el-form :model="merchantCom" ref="servcItemList" class="demo-ruleForm">
                    <div class="table-layout">
                        <el-table border :data="merchantCom.servcItemList" maxHeight="500" style="width: 100%">
                            <el-table-column min-width="300" align="left" prop="name" label="名称"></el-table-column>
                            <el-table-column align="left" width="200" prop="servcCatName"
                                             label="分类名称"></el-table-column>
                            <el-table-column align="left" width="200" prop="servcBrandName"
                                             label="品牌名称"></el-table-column>
                            <el-table-column align="left" prop="fixedSpec" label="规格" width="200"></el-table-column>
                            <el-table-column align="center" prop="desc" label="描述" width="300">
                                <template slot-scope="scope">
                                    <el-form-item :prop="'servcItemList.' + scope.$index + '.desc'">
                                        <el-input class="width-1.5x" type="textarea" :rows="2" placeholder="请输入内容"
                                                  v-model="scope.row.desc"></el-input>
                                    </el-form-item>
                                </template>
                            </el-table-column>
                            <el-table-column align="center" prop="unit" label="单位" width="100"></el-table-column>
                            <el-table-column align="left" label="操作">
                                <template slot-scope="scope">
                                    <a class="swb-btn-link" @click="removeServc(scope.$index)">移除</a>
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                </el-form>
            </div>
        </div>
        <div class="content-caption second">附件信息</div>
        <a class="swb-btn swb-btn-small" @click="showDialogFile();">上传</a>
        <div class="file-view-list" v-if="deviceRequireFileList != null && deviceRequireFileList.length > 0">
            <div class="file-view-header">
                <div class="file-name">名称</div>
                <div class="file-opera">操作</div>
            </div>
            <template v-for="(fileInfo, index) in deviceRequireFileList">
                <swb-file-item-li :trackKey="index" :fileName="fileInfo.name" :fileBrowseUrl="fileInfo.fileBrowseUrl"
                                  :fileUuid="fileInfo.fileUuid" :deletable="true"
                                  :onDelete="deleteFile"></swb-file-item-li>
            </template>
        </div>
    </div>
</template>

<script>
import { Utils } from '../../app.base'
import { MsgBox, Vue } from '../../app.vues'
import { goodsInSelectDlg, goodsInSelectGroupDlg, servcInSelectDlg } from './dialog'
import { openVendorSelectComnDlg } from '../vendor/selectDlg'
import { openSkuListSelectDlg } from '../goods/selectDlg'
import { showAsmblAccDefSelectDlg } from '../asmblAcc/dialog'
import { openRetailerComTreeMultiSelectDlg } from '../orgStruct/selectDlg'
import { fileUploadGroupShowDlg } from '../comn/dialog'
import { getMerchantBizParam } from '../asset/assetMain'

import devcReqrApi from '../../api/devcReqr'
import devcDefApi from '../../api/devcDef'
import merchantComnApi from '../../api/merchtComn'

import SwbGoodsInSelect from './GoodsInSelect';
import SwbServcInSelect from './ServcInSelect';
import SwbComnFilesUpload from '../ctrl/ComnFilesUpload';
import SwbFileItemLi from '../ctrl/FileItemLi';

Vue.regist(SwbGoodsInSelect);

Vue.regist(SwbServcInSelect);

Vue.regist(SwbComnFilesUpload);

Vue.regist(SwbFileItemLi);

export default {
    name: 'swb-create-require-item-for-batch',
    desc: '创建请购单添加商品和服务组件-多机构',
    props: ['id', 'audoAuditorFlag', 'onlyForAsmblAcc', 'lowCostFlag', 'reloadItem'],
    data: function () {
        return {
            merchantComList: [],
            deviceRequireFileList: [],
            //
            deviceRequireVoucher: {
                goodsItemList: [],
                servcItemList: [],
            },
            purchType: getEnumInfoWith('purchType', 'name', 'Goods').value,
            bizFormId: null,
            bizAreaId: null,
            totalAsmblAccSetCount: 0,
            centBuyModeList: [{'value': true, text: '集采'}, {'value': false, text: '自采'}],
            showAssetInfo: false,
        }
    },
    watch: {
        onlyForAsmblAcc: function (newValue, oldValue) {
            console.log('onlyForAsmblAcc_____________________________________________');
            if(Utils.isTrue(newValue)) {
                let merchantComList = this.merchantComList || [];
                for(let i = 0; i < merchantComList.length; i++) {
                    let merchantCom = merchantComList[i];
                    let goodsItemList = merchantCom.goodsItemList || [];
                    for(let j = 0; j < goodsItemList.length; j++) {
                        let goodsItem = goodsItemList[j];
                        goodsItem.onlyForAsmblAcc = true;
                        //
                        this.onlyForAsmblAccChange(merchantCom, i, j, true);
                    }
                }
                this.merchantComList = Utils.merge([], merchantComList);
            }
        },
        id: function (newValue, oldValue) {
            console.log('id_____________________________________________');
        },
        reloadItem: function (newValue, oldValue) {
            console.log('reloadItem_____________________________________________');
            if(oldValue != newValue) {
                this.getDeviceRequireVoucher(this.id);
            }
        },
    },
    created: function () {
        let self = this;
        if(!Utils.isNoB(this.id)) {
            this.getDeviceRequireVoucher(this.id);
        }
        getMerchantBizParam('finac.mgmt.enabled', function (result) {  // 财务管理
            self.finacMgmtEnabled = Utils.isTrue(result);
            if(self.finacMgmtEnabled) {
                self.getComBizParamList();
            }
        }, 0);
        // 交易中是否展示资产相关信息
        getMerchantBizParam('display.asset.related.info.in.trading', function (result) {
            self.showAssetInfo = Utils.isTrue(result);
        });
    },
    methods: {
        getComBizParamList() {
            let self = this;
            let postData = {
                code: 'asset.finac.enabled',
                value: 'true'
            };
            merchantComnApi.getComBizParamList(postData, function (result) {
                if(result.type == 'info') {
                    let comBizParamList = result.data;
                    if(comBizParamList.length == 0) {
                        self.usableRealComIds = [-1];
                    } else {
                        self.usableRealComIds = comBizParamList.pluck('realComId');
                    }
                } else {
                    MsgBox.warning(result.message);
                }
            })
        },
        getDeviceRequireVoucher: function (id) {
            let self = this;
            let postData = {
                id: id
            };
            let theLoad = MsgBox.loading();
            devcReqrApi.getDeviceRequireVoucherInfo(postData, function (result) {
                if(result.type === 'info') {
                    let deviceRequireVoucher = result.data;
                    self.purchType = deviceRequireVoucher.purchType;
                    let goodsItemList = deviceRequireVoucher.goodsItemList;
                    // requireComId 拆分项信息
                    let merchantComList = [];
                    for(let i = 0; i < goodsItemList.length; i++) {
                        let goodsItem = goodsItemList[i];
                        //
                        let merchantCom = merchantComList.find(function (merchantCom) {
                            return merchantCom.id == goodsItem.requireComId;
                        });
                        let expends = [];
                        let newGoodsItemList = [];
                        let wtxAmount = 0;
                        if(!Utils.isNoB(merchantCom)) {
                            newGoodsItemList = merchantCom.goodsItemList || [];
                            expends = merchantCom.expends || [];
                            //
                            wtxAmount = parseFloat(merchantCom.wtxAmount || 0) + parseFloat(goodsItem.wtxAmount || 0);
                        } else {
                            merchantCom = {
                                id: goodsItem.requireComId,
                                name: goodsItem.requireComName,
                                bizFormId: goodsItem.bizFormId,
                                bizAreaId: goodsItem.bizAreaId,
                                realComId: goodsItem.requireRealComId,
                                goodsItemList: [],
                            };
                            wtxAmount = parseFloat(goodsItem.wtxAmount || 0)
                        }
                        newGoodsItemList.push(goodsItem);
                        // 组装件
                        let itemList = goodsItem.itemList || [];
                        for(let j = 0; j < itemList.length; j++) {
                            let item = itemList[j];
                            if(goodsItem.quantity == 0) {
                                item.setQuantity = item.quantity;
                            } else {
                                item.setQuantity = item.quantity / goodsItem.quantity;
                            }
                            wtxAmount += parseFloat(item.wtxAmount || 0);
                        }
                        if(itemList.length > 0) {
                            if(expends.indexOf(goodsItem.deviceId) < 0) {
                                expends.push(goodsItem.deviceId)
                            }
                        }
                        merchantCom.expends = Utils.merge([], expends);
                        merchantCom.goodsItemList = Utils.merge([], newGoodsItemList);
                        // 计算含税总金额
//                            let wtxAmount = 0;
//                            for (let i = 0, len = newGoodsItemList.length; i < len; i++) {
//                                let goodsItemInfo = newGoodsItemList[i];
//                                wtxAmount += parseFloat(goodsItemInfo.wtxAmount || 0);
//                                // 组装件列表
//                                let accItemList = goodsItemInfo.itemList || [];
//                                for (let j = 0, a = accItemList.length; j < a; j++) {
//                                    let accItem = accItemList[j];
//                                    wtxAmount += parseFloat(accItem.wtxAmount || 0);
//                                }
//                            }
                        merchantCom.wtxAmount = wtxAmount;
                        // 包含组装件总数
                        self.countTotalAsmblAccSetCount(merchantCom);
                        if(newGoodsItemList.length == 1) {
                            merchantComList.push(merchantCom);
                        }
                    }
                    self.merchantComList = Utils.merge([], merchantComList);
                    self.deviceRequireFileList = Utils.merge([], deviceRequireVoucher.deviceRequireFileList);
                } else {
                    MsgBox.warning(result.message);
                }
                theLoad.hide();
            });
        },
//            getRetailerComInfo: function () {
//                let self = this;
//                retailerApi.getRetailerCom({}, function (result) {
//                    if (result.type == "info") {
//                        let merchantComList = self.merchantComList || [];
//                        let comInfo = result.data || {};
//                        let merchantCom = {};
//                        merchantCom.id = comInfo.id;
//                        merchantCom.name = comInfo.name;
//                        merchantCom.bizFormId = comInfo.bizFormId;
//                        merchantCom.bizAreaId = comInfo.bizAreaId;
//                        merchantCom.goodsItemList = [];
//                        merchantCom.servcItemList = [];
//                        merchantComList.push(merchantCom);
//                        //
//                        self.merchantComList = Utils.merge([], merchantComList);
//                    } else {
//                        MsgBox.warning(result.message);
//                    }
//                })
//            },
        // 选择机构
        selectMerchtComList: function () {
            let self = this;
            let params = {
                model: {
                    comIdColumn: 'id', //
                    comNameColumn: 'name',
                    comBizFormIdColumn: 'bizFormId',
                    comBizAreaIdColumn: 'bizAreaId',
                },
                showCheckboxLevel1: true,
                showCheckboxLevel2: true,
                showCheckboxLevel3: true,
                checkStrictly: true,
                bizDepart: true,
                usableRealComIds: self.usableRealComIds,
                optionalState: [1, 3],
                defalultState: [1]
            };
            openRetailerComTreeMultiSelectDlg(params, Utils.merge([], this.merchantComList), function (result) {
                let comList = result.data || [];
                if(comList.length > 0) {
                    let merchantComList = Utils.merge([], self.merchantComList);
                    let resultList = [];
                    for(let i = 0; i < comList.length; i++) {
                        let comInfo = comList[i];
                        //
                        let theCom = merchantComList.find(function (com) {
                            return com.id == comInfo.id;
                        });
                        if(theCom == null) {
                            let merchantCom = {};
                            merchantCom.id = comInfo.id;
                            merchantCom.name = comInfo.name;
                            merchantCom.bizFormId = comInfo.bizFormId;
                            merchantCom.bizAreaId = comInfo.bizAreaId;
                            merchantCom.realComId = comInfo.realComId;
                            merchantCom.goodsItemList = [];
                            merchantCom.servcItemList = [];
                            resultList.push(merchantCom);
                        } else {
                            resultList.push(theCom);
                        }
                    }
                    self.merchantComList = Utils.merge([], resultList);
                }
            });
        },
        removeMerchantCom: function (index) {
            let self = this;
            let merchantComList = this.merchantComList || [];
            if(merchantComList.length <= 1) {
                MsgBox.warning('至少保留一个机构');
                return;
            }
            merchantComList.splice(index, 1);
            //
            this.merchantComList = Utils.merge([], merchantComList);
        },
        // 计算含税总金额
        calWtxAmount: function (index) {
            let merchantComList = this.merchantComList || [];
            let deviceRequireVoucher = merchantComList[index] || {};
            let goodsItemList = deviceRequireVoucher.goodsItemList || [];
            // 计算含税总金额
            let wtxAmount = 0;
            for(let i = 0, len = goodsItemList.length; i < len; i++) {
                let goodsItemInfo = goodsItemList[i];
                wtxAmount += parseFloat(goodsItemInfo.wtxAmount || 0);
                // 组装件列表
                let accItemList = goodsItemInfo.itemList || [];
                for(let j = 0, a = accItemList.length; j < a; j++) {
                    let accItem = accItemList[j];
                    wtxAmount += parseFloat(accItem.wtxAmount || 0);
                }
            }
            merchantComList[index].wtxAmount = wtxAmount;
            //
            this.merchantComList = Utils.merge([], merchantComList);
        },
        // 创建虚拟资产
        createVirtualAssets: function (asmblAccList) {
            let noneValId = -1;
            let noneStrVal = '';
            let item = {};
            item.deviceId = noneValId;
            item.devcTitle = '组装件';
            item.devcName = noneStrVal;
            item.devcCatName = noneStrVal;
            item.devcBrandName = noneStrVal;
            item.devcModel = noneStrVal;
            item.devcFixedSpec = noneStrVal;
            item.devcUnit = noneStrVal;
            item.assetDefNo = noneStrVal;
            item.oldCustomized = false;
            item.customized = false;
            //
            item.name = '组装件';
            item.asmblAccFlag = false;
            item.centBuyMode = true;
            item.reqCentBuyMode = false;
            item.skuId = noneValId;
            item.assetDefId = noneValId;
            item.title = noneStrVal;
            item.bizAreaCode = null;
            item.bizFormCode = null;
            item.vendorName = noneStrVal;
            item.vendorRealComId = noneValId;
            item.vendorRealComName = null;
            item.vendorRealComCode = null;
            item.vendorId = noneValId;
            item.contractId = -1;
            item.model = noneStrVal;
            item.fixedSpec = noneStrVal;
            item.modelSpec = noneStrVal;
            item.price = 0.00;
            item.wtxAmount = 0.00;
            item.oldPrice = 0.00;
            item.ntxPrice = 0.00;
            item.taxRate = 0;
            item.wrntPeriod = 0;
            item.arriveDays = 0;
            item.goodsCatName = noneStrVal;
            item.goodsBrandName = noneStrVal;
            item.unit = noneStrVal;
            item.quantity = 1;
            item.itemList = [];
            item.onlyForAsmblAcc = true;    // 仅组装件
            item.asmblAccSetCount = asmblAccList.length || 0;
            item.itemList = Utils.merge([], asmblAccList);
            return item;
        },
        // 批量选择商品
        selectGoodsListForBatch: function () {
            let self = this;
            let merchantComList = self.merchantComList || [];
            if(merchantComList.length <= 0) {
                MsgBox.warning('请选择机构信息');
                return;
            }
            let realComIds = [];
            for(let i = 0; i < merchantComList.length; i++) {
                let merchantCom = merchantComList[i];
                if(!realComIds.contains(merchantCom.realComId)) {
                    realComIds.push(merchantCom.realComId);
                }
            }
            //
            let filter = {
                contractRealComIds: realComIds,
                forReq: true, // 标准合同为contractRealComId 的 或 框架合同 或 无合同
                skuFlag: true, // 关联sku
                assetDefFlag: true, // 关联定义
                contractEnded: false, // 合同未到期 或 无合同
            };
            let params = {};
            params.checkIds = [];
            params.filter = filter;
            params.normalized = self.finacMgmtEnabled;
            goodsInSelectGroupDlg(params, function (result) {
                let itemList = result || [];
                //
                for(let i = 0; i < merchantComList.length; i++) {
                    let merchantCom = merchantComList[i];
                    let deviceIds = [];
                    let asmblAccList = [];
                    //
                    let goodsItemList = merchantCom.goodsItemList || [];
                    let thisDeviceIds = goodsItemList.pluck('deviceId') || [];
                    for(let j = 0; j < itemList.length; j++) {
                        let deviceRequirer = itemList[j];
                        if(thisDeviceIds.indexOf(deviceRequirer.id) < 0) {
                            if(deviceRequirer.contractKindId == 0 && deviceRequirer.contractRealComId != merchantCom.realComId) {
                                continue;
                            }
                            let item = self.makeGoodsItem(deviceRequirer);
                            //
                            if(Utils.isTrue(item.asmblAccFlag)) {  // 组装件单独放到一个虚拟资产下
                                item.accDefNo = deviceRequirer.innerCode;
                                item.accDefId = deviceRequirer.assetDefId;
                                //
                                asmblAccList.push(item)
                            } else {
                                goodsItemList.push(item);
                                deviceIds.push(deviceRequirer.id);
                            }
                        }
                    }
                    if(asmblAccList.length > 0) {   // 存在单独的组装件-创建虚拟资产
                        let virtualAssets = null;
                        if(goodsItemList.length > 0) {
                            virtualAssets = goodsItemList.find(function (goodsItem) {
                                return goodsItem.deviceId == -1;
                            });
                        }
                        if(Utils.isNoB(virtualAssets)) {
                            virtualAssets = self.createVirtualAssets(asmblAccList);
                            //
                            goodsItemList.push(virtualAssets);
                        } else {
                            let currentItemList = virtualAssets.itemList || [];
                            currentItemList = currentItemList.concat(asmblAccList);
                            virtualAssets.itemList = Utils.merge([], currentItemList);
                        }
                    }
                    // 计算含税总金额
                    let wtxAmount = 0;
                    for(let a = 0, len = goodsItemList.length; a < len; a++) {
                        let goodsItemInfo = goodsItemList[a];
                        wtxAmount += parseFloat(goodsItemInfo.wtxAmount || 0);
                        // 组装件列表
                        let accItemList = goodsItemInfo.itemList || [];
                        for(let b = 0, c = accItemList.length; b < c; b++) {
                            let accItem = accItemList[b];
                            wtxAmount += parseFloat(accItem.wtxAmount || 0);
                        }
                    }
                    merchantCom.wtxAmount = wtxAmount;
                    merchantCom.goodsItemList = Utils.merge([], goodsItemList);
                    if(deviceIds.length > 0 && !Utils.isTrue(self.onlyForAsmblAcc)) {
                        self.getAccDefList(merchantCom, i, deviceIds);
                    }
                }
                self.merchantComList = Utils.merge([], merchantComList);
            });
        },
        // 选择入选商品(不选组装件的)
        showGoodsListDlg: function (merchantCom, index, goodsIndex) {
            let self = this;
            let goodsItemList = merchantCom.goodsItemList || [];
            let itemIds = goodsItemList.pluck('deviceId');
            // 虚拟资产下的组装件回显禁用
            if(goodsItemList.length > 0) {
                for(let i = 0; i < goodsItemList.length; i++) {
                    if(goodsItemList[i].deviceId == -1 && !Utils.isNoB(goodsItemList[i].itemList) && goodsItemList[i].itemList.length > 0) {
                        let asmblAccIds = goodsItemList[i].itemList.pluck('deviceId');
                        itemIds = itemIds.concat(asmblAccIds);
                        break;
                    }
                }
            }
            let params = {};
            params.checkIds = itemIds;
            params.filter = {
                contractRealComId: merchantCom.realComId,
                forReq: true, // 标准合同为contractRealComId 的 或 框架合同 或 无合同
                skuFlag: true, // 关联sku
                assetDefFlag: true, // 关联定义
                contractEnded: false, // 合同未到期 或 无合同
            };
            if(merchantCom.bizFormId != null && merchantCom.bizFormId != -1) {
                params.filter.bizFormIds = [merchantCom.bizFormId, -1];
            }
            if(merchantCom.bizAreaId != null && merchantCom.bizAreaId != -1) {
                params.filter.bizAreaIds = [merchantCom.bizAreaId, -1];
            }
            params.normalized = self.finacMgmtEnabled;
            if(!Utils.isNoB(goodsIndex)) {
                params.radio = true;
            }
            goodsInSelectGroupDlg(params, function (result) {
                let itemList = result || [];
                let asmblAccList = [];
                let deviceIds = [];
                itemList.forEach(function (deviceRequirer) {
                    let item = self.makeGoodsItem(deviceRequirer);
                    //
                    if(!Utils.isNoB(goodsIndex)) {
                        goodsItemList[goodsIndex] = Utils.merge({}, item);
                        deviceIds.push(deviceRequirer.id);
                    } else {
                        if(Utils.isTrue(item.asmblAccFlag)) {  // 组装件单独放到一个虚拟资产下
                            item.accDefNo = deviceRequirer.innerCode;
                            item.accDefId = deviceRequirer.assetDefId;
                            //
                            asmblAccList.push(item)
                        } else {
                            goodsItemList.push(item);
                            deviceIds.push(deviceRequirer.id);
                        }
                    }
                });
                if(asmblAccList.length > 0) {   // 存在单独的组装件-创建虚拟资产
                    let virtualAssets = self.createVirtualAssets(asmblAccList);
                    //
                    goodsItemList.push(virtualAssets);
                }
                // 计算含税总金额
                let wtxAmount = 0;
                for(let i = 0, len = goodsItemList.length; i < len; i++) {
                    let goodsItemInfo = goodsItemList[i];
                    wtxAmount += parseFloat(goodsItemInfo.wtxAmount || 0);
                }
                merchantCom.wtxAmount = wtxAmount;
                merchantCom.goodsItemList = Utils.merge([], goodsItemList);
                if(deviceIds.length > 0 && !Utils.isTrue(self.onlyForAsmblAcc)) {
                    self.getAccDefList(merchantCom, index, deviceIds, goodsIndex);
                }
                // 计算含税总金额
                self.calWtxAmount(index);
            });
        },
        makeGoodsItem: function (deviceRequirer) {
            let item = {};
            item.deviceId = deviceRequirer.id;
            item.devcTitle = deviceRequirer.devcTitle;
            item.devcName = deviceRequirer.devcName;
            item.devcCatName = deviceRequirer.devcCatName;
            item.devcBrandName = deviceRequirer.devcBrandName;
            item.devcModel = deviceRequirer.devcModel;
            item.devcFixedSpec = deviceRequirer.devcFixedSpec;
            item.devcUnit = deviceRequirer.devcUnit;
            item.assetDefNo = deviceRequirer.innerCode;
            item.oldCustomized = deviceRequirer.customized;
            item.customized = deviceRequirer.customized;
            //
            item.name = deviceRequirer.name;
            item.asmblAccFlag = deviceRequirer.asmblAccFlag;
            item.centBuyMode = deviceRequirer.centBuyMode;
            item.reqCentBuyMode = deviceRequirer.centBuyMode;
            item.skuId = deviceRequirer.skuId;
            item.assetDefId = deviceRequirer.assetDefId;
            item.title = deviceRequirer.title;
            item.bizAreaCode = deviceRequirer.bizAreaCode;
            item.bizFormCode = deviceRequirer.bizFormCode;
            item.vendorName = deviceRequirer.vendorName;
            item.vendorRealComId = deviceRequirer.vendorRealComId;
            item.vendorRealComName = deviceRequirer.vendorRealComName;
            item.vendorRealComCode = deviceRequirer.vendorRealComCode;
            item.vendorId = deviceRequirer.vendorId;
            if(Utils.isTrue(deviceRequirer.contractEnded)) {
                item.contractId = -1;
            } else {
                item.contractTitle = deviceRequirer.contractTitle;
                item.contractId = deviceRequirer.contractId;
                item.contractDateStart = deviceRequirer.contractDateStart;
                item.contractDateEnd = deviceRequirer.contractDateEnd;
            }
            item.model = deviceRequirer.model;
            item.fixedSpec = deviceRequirer.fixedSpec;
            item.modelSpec = deviceRequirer.modelSpec;
            item.price = Utils.isNoB(deviceRequirer.price) ? 0.00 : parseFloat(deviceRequirer.price.toFixed(2));
            item.oldPrice = Utils.isNoB(deviceRequirer.price) ? 0.00 : parseFloat(deviceRequirer.price.toFixed(2));
            item.ntxPrice = Utils.isNoB(deviceRequirer.ntxPrice) ? 0.00 : parseFloat(deviceRequirer.ntxPrice.toFixed(2));
            item.taxRate = deviceRequirer.taxRate;
            item.wrntPeriod = deviceRequirer.wrntPeriod;
            item.arriveDays = deviceRequirer.arriveDays;
            item.goodsCatName = deviceRequirer.goodsCatName;
            item.goodsBrandName = deviceRequirer.goodsBrandName;
            item.unit = deviceRequirer.unit;
            item.quantity = deviceRequirer.quantity || 1;
            item.onlyForAsmblAcc = Utils.isNoB(deviceRequirer.onlyForAsmblAcc) ? Utils.isTrue(this.onlyForAsmblAcc) : Utils.isTrue(deviceRequirer.onlyForAsmblAcc);
            if(Utils.isTrue(item.customized)) {
                item.quantity = 1;
            } else if(Utils.isTrue(item.onlyForAsmblAcc) && !Utils.isTrue(item.asmblAccFlag)) {
                item.quantity = 0;
            }
            item.wtxAmount = (parseFloat(item.price || 0) * parseInt(item.quantity));
            item.message = deviceRequirer.message;
            let adoptedDevices = deviceRequirer.adoptedDevices || [];
            if(adoptedDevices.length > 0) {
                let asmblItems = [];
                for(let i = 0; i < adoptedDevices.length; i++) {
                    let adoptedDevice = adoptedDevices[i];
                    //
                    let asmblItem = {};
                    asmblItem.deviceId = adoptedDevice.id;
                    asmblItem.devcTitle = adoptedDevice.devcTitle;
                    asmblItem.devcName = adoptedDevice.devcName;
                    asmblItem.devcCatName = adoptedDevice.devcCatName;
                    asmblItem.devcBrandName = adoptedDevice.devcBrandName;
                    asmblItem.devcModel = adoptedDevice.devcModel;
                    asmblItem.devcFixedSpec = adoptedDevice.devcFixedSpec;
                    asmblItem.devcUnit = adoptedDevice.devcUnit;
                    asmblItem.accDefNo = adoptedDevice.innerCode;
                    asmblItem.customized = adoptedDevice.customized;
                    //
                    asmblItem.name = adoptedDevice.name;
                    asmblItem.asmblAccFlag = adoptedDevice.asmblAccFlag;
                    asmblItem.centBuyMode = adoptedDevice.centBuyMode;
                    asmblItem.reqCentBuyMode = adoptedDevice.centBuyMode;
                    asmblItem.skuId = adoptedDevice.skuId;
                    asmblItem.accDefId = adoptedDevice.assetDefId;
                    asmblItem.title = adoptedDevice.title;
                    asmblItem.bizAreaCode = adoptedDevice.bizAreaCode;
                    asmblItem.bizFormCode = adoptedDevice.bizFormCode;
                    asmblItem.vendorName = adoptedDevice.vendorName;
                    asmblItem.vendorRealComId = adoptedDevice.vendorRealComId;
                    asmblItem.vendorRealComName = adoptedDevice.vendorRealComName;
                    asmblItem.vendorRealComCode = adoptedDevice.vendorRealComCode;
                    asmblItem.vendorId = adoptedDevice.vendorId;
                    if(Utils.isTrue(adoptedDevice.contractEnded)) {
                        asmblItem.contractId = -1;
                    } else {
                        asmblItem.contractTitle = adoptedDevice.contractTitle;
                        asmblItem.contractId = adoptedDevice.contractId;
                        asmblItem.contractDateStart = adoptedDevice.contractDateStart;
                        asmblItem.contractDateEnd = adoptedDevice.contractDateEnd;
                    }
                    asmblItem.model = adoptedDevice.model;
                    asmblItem.fixedSpec = adoptedDevice.fixedSpec;
                    asmblItem.modelSpec = adoptedDevice.modelSpec;
                    asmblItem.price = adoptedDevice.price;
                    asmblItem.ntxPrice = adoptedDevice.ntxPrice;
                    asmblItem.taxRate = adoptedDevice.taxRate;
                    asmblItem.wrntPeriod = adoptedDevice.wrntPeriod;
                    asmblItem.arriveDays = adoptedDevice.arriveDays;
                    asmblItem.goodsCatName = adoptedDevice.goodsCatName;
                    asmblItem.goodsBrandName = adoptedDevice.goodsBrandName;
                    asmblItem.unit = adoptedDevice.unit;
                    asmblItem.quantity = adoptedDevice.quantity || 1;
                    asmblItem.wtxAmount = parseFloat(asmblItem.price || 0) * parseInt(asmblItem.quantity || 0);
                    asmblItem.message = adoptedDevice.message;
                    asmblItems.push(asmblItem);
                }
                item.itemList = asmblItems;
            } else {
                item.itemList = [];
            }
            return item;
        },
        // 根据入选商品查询对应的组装件信息
        getAccDefList: function (merchantCom, index, deviceIds, goodsIndex) {
            let self = this;
            let goodsItemList = merchantCom.goodsItemList;
            let postData = {
                deviceIds: deviceIds,
                bizAreaId: merchantCom.bizAreaId,
                bizFormId: merchantCom.bizFormId
            };
            let expends = merchantCom.expends || [];
            devcReqrApi.getAdoptedDeviceAsmblAccList(postData, function (result) {
                if(result.type == 'info') {
                    let itemMap = result.data || {};
                    for(let i = 0; i < goodsItemList.length; i++) {
                        let goodsItem = goodsItemList[i];
                        let itemList = goodsItem.itemList || [];
                        if(itemList == null || itemList.length <= 0) {
                            if(deviceIds.indexOf(goodsItem.deviceId) > -1) {
                                itemList = itemMap[goodsItem.deviceId] || [];
                            }
                        }
                        //
                        if(itemList.length > 0) {
                            let quantity = 0;
                            itemList.forEach(function (item) {
                                quantity = quantity + item.quantity;
                                item.setQuantity = item.quantity;
                                item.wtxAmount = parseFloat(item.price || 0) * parseInt(item.quantity || 0);
                            });
                            //
                            goodsItem.asmblAccDefCount = quantity;
                            goodsItem.asmblAccSetCount = quantity;
                            goodsItem.itemList = Utils.merge([], itemList);
                            if(expends.indexOf(goodsItem.deviceId) < 0) {
                                expends.push(goodsItem.deviceId)
                            }
                        }
                    }
                    merchantCom.expends = Utils.merge([], expends);
                    if(!Utils.isNoB(goodsIndex)) {
                        merchantCom.goodsItemList[goodsIndex] = Utils.merge({}, goodsItemList[0]);
                    } else {
                        merchantCom.goodsItemList = Utils.merge([], goodsItemList);
                    }
                    //
                    self.countTotalAsmblAccSetCount(merchantCom);
                    //
                    let merchantComList = self.merchantComList || [];
                    merchantComList[index] = Utils.merge({}, merchantCom);
                    self.merchantComList = Utils.merge([], merchantComList);
                    // 计算含税总金额
                    self.calWtxAmount(index);
                } else {
                    MsgBox.warning(result.message);
                }
            });
        },
        // 切换是否定制
        changeCustomized: function (merchantCom, comIndex, goodsIndex) {
            let goodsItemList = merchantCom.goodsItemList;
            let goodsItem = goodsItemList[goodsIndex];
            //
            goodsItem.price = goodsItem.oldPrice;
            goodsItem.ntxPrice = parseFloat((parseFloat(goodsItem.price) / (1 + (parseFloat(goodsItem.taxRate) * 0.01))).toFixed(2));
            goodsItem.wtxAmount = parseFloat(goodsItem.price || 0) * parseInt(goodsItem.quantity || 0);
            //
            let merchantComList = this.merchantComList || [];
            merchantComList[comIndex] = Utils.merge({}, merchantCom);
            this.merchantComList = Utils.merge([], merchantComList);
            // 计算含税总金额
            this.calWtxAmount(comIndex);
        },
        // 入选商品的金额变更修改
        changeGoodsPrice: function (merchantCom, comIndex, index, price, isPrice) {
            let goodsItemList = merchantCom.goodsItemList;
            let goodsItem = goodsItemList[index];
            if(!isPrice) {
                // 输入的未税价，根据未税价计算含税价
                price = (parseFloat(goodsItem.ntxPrice) * (1 + (parseFloat(goodsItem.taxRate) * 0.01))).toFixed(2);
            }
            if(Utils.isNoB(price) || !Utils.isMoneyStr(price) || parseFloat(price) <= 0) {
                MsgBox.warning('请输入正确的金额');
                return;
            }
            if(isPrice) {
                // 根据税率计算未税价
                goodsItem.ntxPrice = (parseFloat(goodsItem.price) / (1 + (parseFloat(goodsItem.taxRate) * 0.01))).toFixed(2);
            } else {
                goodsItem.price = price;
            }
            // 计算含税总金额
            goodsItem.wtxAmount = parseFloat(goodsItem.price || 0) * parseInt(goodsItem.quantity || 0);
            merchantCom.goodsItemList = Utils.merge([], goodsItemList);
            //
            let merchantComList = this.merchantComList || [];
            merchantComList[comIndex] = Utils.merge({}, merchantCom);
            this.merchantComList = Utils.merge([], merchantComList);
            // 计算含税总金额
            this.calWtxAmount(comIndex);
        },
        // 入选商品的数量修改
        goodsQuantity: function (merchantCom, comIndex, goodsIndex, quantity) {
            let goodsItemList = merchantCom.goodsItemList;
            let goodsItem = goodsItemList[goodsIndex];
            if(!Utils.isNumber(quantity) || quantity <= 0) {
                MsgBox.warning('请输入大于0的数字');
                return;
            }
            goodsItem.wtxAmount = parseFloat(goodsItem.price || 0) * parseInt(quantity);
            let itemList = goodsItem.itemList || [];
            if(Utils.isNoB(this.id)) {
                let asmblAccReqCount = 0;
                let asmblAccSetCount = 0;
                for(let i = 0; i < itemList.length; i++) {
                    let item = itemList[i];
                    if(!Utils.isNoB(item.setQuantity)) {
                        item.quantity = parseInt(item.setQuantity) * parseInt(quantity);
                        asmblAccSetCount = parseInt(asmblAccSetCount) + (parseInt(item.setQuantity) * parseInt(quantity));
                        asmblAccReqCount = parseInt(asmblAccReqCount) + (parseInt(item.reqQuantity) * parseInt(quantity));
                        item.wtxAmount = parseFloat(item.price || 0) * parseInt(item.quantity || 0);
                    }
                }
                goodsItem.asmblAccSetCount = asmblAccSetCount;
                goodsItem.asmblAccReqCount = asmblAccReqCount;
            }
            // 计算含税总金额
            merchantCom.goodsItemList = Utils.merge([], goodsItemList);
            //
            this.countTotalAsmblAccSetCount(merchantCom);
            //
            let merchantComList = this.merchantComList || [];
            merchantComList[comIndex] = Utils.merge({}, merchantCom);
            this.merchantComList = Utils.merge([], merchantComList);
            // 计算含税总金额
            this.calWtxAmount(comIndex);
        },
        // 组装件数量修改
        accQuantity: function (merchantCom, comIndex, goodsIndex, index) {
            let goodsItemList = merchantCom.goodsItemList;
            let goodsItem = goodsItemList[goodsIndex];
            let itemList = goodsItem.itemList || [];
            let item = itemList[index];
            if(!Utils.isNumber(item.quantity) || item.quantity <= 0) {
                MsgBox.warning('请输入大于0的数字');
                return;
            }
            let asmblAccSetCount = 0;
            let asmblAccReqCount = 0;
            for(let i = 0; i < itemList.length; i++) {
                let item = itemList[i];
                if(!Utils.isNoB(item.quantity)) {
                    if(Utils.isTrue(goodsItem.onlyForAsmblAcc)) {
                        asmblAccSetCount = parseInt(asmblAccSetCount) + parseInt(item.quantity);
                        asmblAccReqCount = parseInt(asmblAccReqCount) + parseInt(item.reqQuantity);
                    } else {
                        asmblAccSetCount = parseInt(asmblAccSetCount) + parseInt(item.quantity);
                        asmblAccReqCount = parseInt(asmblAccReqCount) + parseInt(item.reqQuantity);
                    }
                    item.wtxAmount = parseFloat(item.price || 0) * parseInt(item.quantity || 0);
                }
            }
            goodsItem.itemList = Utils.merge([], itemList);
            goodsItem.asmblAccSetCount = asmblAccSetCount;
            goodsItem.asmblAccReqCount = asmblAccReqCount;
            merchantCom.goodsItemList = Utils.merge([], goodsItemList);
            //
            this.countTotalAsmblAccSetCount(merchantCom);
            // 计算含税总金额
            this.calWtxAmount(comIndex);
        },
        countTotalAsmblAccSetCount(merchantCom) {
            let goodsItemList = merchantCom.goodsItemList;
            let totalAsmblAccSetCount = 0;
            goodsItemList.forEach(function (theItem) {
                if(!Utils.isNoB(theItem.asmblAccSetCount)) {
                    totalAsmblAccSetCount = totalAsmblAccSetCount + theItem.asmblAccSetCount;
                }
            });
            merchantCom.totalAsmblAccSetCount = totalAsmblAccSetCount;
        },
        // 入围商品选择供应商
        addAdoptedGoods: function (merchantCom, goodsIndex, comIndex) {
            let self = this;
            let goodsItemList = merchantCom.goodsItemList;
            let goodsItem = goodsItemList[goodsIndex];
            openVendorSelectComnDlg(this, {
                showContract: true,
                showOrder: true,
                showBizRel: true,
                multiSelect: false
            }, function (voucherResult) {
                let voucherId = voucherResult.checkedId;
                //
                let catId = goodsItem.goodsCatId;
                let brandId = goodsItem.goodsBrandId;
                openSkuListSelectDlg(false, {
                    merchantId: voucherId,
                    merchantType: getEnumInfoWith('merchantType', 'name', 'Vendor').value,
                    catId: catId,
                    brandId: brandId,
                    saleHalted : false
                }, [], function (mkuResult) {
                    let postData = {};
                    let skuId = mkuResult.id;
                    postData.skuId = skuId;
                    postData.vendorId = voucherId;
                    postData.vendorName = voucherResult.checkedList.name;
                    postData.model = mkuResult.model;
                    postData.fixedSpec = mkuResult.fixedSpec;
                    self.getContractGoodsItem(voucherId, skuId, null, merchantCom.bizAreaId, merchantCom.bizFormId, function (result) {
                        if(result != null) {
                            postData.price = result.price;
                            postData.ntxPrice = result.ntxPrice;
                            postData.taxRate = result.taxRate;
                            postData.contractId = result.contractId;
                            postData.contractDateStart = result.dateStart;
                            postData.contractDateEnd = result.dateEnd;
                            postData.contractNo = result.no;
                        } else {
                            postData.price = mkuResult.salePrice;
                            postData.ntxPrice = mkuResult.salePrice;
                        }
                        postData.id = goodsItem.deviceId;
                        postData.bizFormId = merchantCom.bizFormId != null ? merchantCom.bizFormId : -1;
                        postData.bizAreaId = merchantCom.bizAreaId != null ? merchantCom.bizAreaId : -1;
                        devcReqrApi.updateAdoptedDeviceSku(postData, function (result) {
                            if(result.type == 'info') {
                                MsgBox.success('添加成功');
                                goodsItem.vendorId = postData.vendorId;
                                goodsItem.vendorName = postData.vendorName;
                                goodsItem.model = postData.model;
                                goodsItem.fixedSpec = postData.fixedSpec;
                                goodsItem.price = postData.price;
                                goodsItem.ntxPrice = postData.ntxPrice;
                                goodsItem.taxRate = postData.taxRate;
                                goodsItem.contractId = postData.contractId;
                                goodsItem.contractDateStart = postData.contractDateStart;
                                goodsItem.contractDateEnd = postData.contractDateEnd;
                                goodsItem.contractNo = postData.contractNo;
                                goodsItem.wtxAmount = parseFloat(goodsItem.price || 0) * parseInt(goodsItem.quantity || 0);
                                //
                                merchantCom.goodsItemList = Utils.merge([], goodsItemList);
                                //
                                let merchantComList = self.merchantComList || [];
                                merchantComList[comIndex] = Utils.merge({}, merchantCom);
                                self.merchantComList = Utils.merge([], merchantComList);
                                // 计算含税总金额
                                self.calWtxAmount(comIndex);
                            } else {
                                MsgBox.warning(result.message);
                            }
                        })
                    })
                })
            })
        },
        // 组装件选择商品
        addAccSku: function (merchantCom, comIndex, index, goodIndex) {
            let self = this;
            let goodsItemList = merchantCom.goodsItemList;
            let goodsItem = goodsItemList[goodIndex];
            let itemList = goodsItem.itemList;
            let item = itemList[index];
            openVendorSelectComnDlg(this, {
                showContract: true,
                showOrder: true,
                showBizRel: true,
                multiSelect: false
            }, function (voucherResult) {
                let voucherId = voucherResult.checkedId;
                openSkuListSelectDlg(false, {
                    merchantId: voucherId,
                    merchantType: getEnumInfoWith('merchantType', 'name', 'Vendor').value,
                    catId: item.goodsCatId,
                    brandId: item.brandId,
                    saleHalted : false
                }, [], function (mkuResult) {
                    let skuId = mkuResult.id;
                    item.skuId = skuId;
                    item.vendorId = voucherId;
                    item.vendorName = voucherResult.checkedList.name;
                    item.model = mkuResult.model;
                    item.fixedSpec = mkuResult.fixedSpec;
                    item.bizFormId = !Utils.isNoB(merchantCom.bizFormId) ? merchantCom.bizFormId : -1;
                    item.bizAreaId = !Utils.isNoB(merchantCom.bizAreaId) ? merchantCom.bizAreaId : -1;
                    item.assetDefId = item.accDefId;
                    item.asmblAccFlag = true;
                    self.getContractGoodsItem(mkuResult.merchantId, skuId, goodsItem.contractId, merchantCom.bizAreaId, merchantCom.bizFormId, function (result) {
                        if(result != null) {
                            item.price = result.price;
                            item.ntxPrice = result.ntxPrice;
                            item.taxRate = result.taxRate;
                            item.contractId = result.contractId;
                            item.contractDateStart = result.dateStart;
                            item.contractDateEnd = result.dateEnd;
                            item.contractNo = result.no;
                        } else {
                            item.price = mkuResult.salePrice;
                            item.ntxPrice = mkuResult.salePrice;
                        }
                        item.wtxAmount = parseFloat(item.price || 0) * parseInt(item.quantity || 0);
                        devcReqrApi.updateAdoptedDevice(item, function (result) {
                            if(result.type == 'info') {
                                MsgBox.success('添加成功');
                                item.deviceId = result.data;
                                goodsItem.itemList = Utils.merge([], itemList);
                                merchantCom.goodsItemList = Utils.merge([], goodsItemList);
                                //
                                let merchantComList = self.merchantComList || [];
                                merchantComList[comIndex] = Utils.merge({}, merchantCom);
                                self.merchantComList = Utils.merge([], merchantComList);
                                // 计算含税总金额
                                self.calWtxAmount(comIndex);
                            } else {
                                MsgBox.warning(result.message);
                            }
                        })
                    })
                })
            })
        },
        selectAdoptedGoods: function (merchantCom, comIndex, index, goodsIndex) {
            let self = this;
            let goodsItemList = merchantCom.goodsItemList || [];
            let goodsItem = goodsItemList[goodsIndex];
            let itemList = goodsItem.itemList;
            let item = itemList[index];
            let filter = {
                asmblAccFlag: true,
                bizAreaId: merchantCom.bizAreaId,
                bizFormId: merchantCom.bizFormId,
                bizAreaFlag: true,
                bizFormFlag: true,
                catId: item.goodsCatId,
                brandId: item.goodsBrandId,
                goodsModel: item.model,
                disabled: false,
            };
            let params = {};
            params.filter = filter;
            params.skuFlag = true;
            params.checkBox = false;
            params.showTable = true;
            params.showCatBrandTable = true;
            params.showCatBrandModelTable = true;
            params.contractEnded = false;// 未结束的
            params.showCentBuyFlag = false;
            goodsInSelectDlg(params, function (result) {
                item.deviceId = result.id;
                item.name = result.name;
                item.asmblAccFlag = result.asmblAccFlag;
                item.skuId = result.skuId;
                item.title = result.title;
                item.bizAreaCode = result.bizAreaCode;
                item.bizFormCode = result.bizFormCode;
                item.vendorName = result.vendorName;
                item.vendorId = result.vendorId;
                if(Utils.isTrue(result.contractEnded)) {
                    item.contractId = -1;
                } else {
                    item.contractTitle = result.contractTitle;
                    item.contractId = result.contractId;
                    item.contractDateStart = result.contractDateStart;
                    item.contractDateEnd = result.contractDateEnd;
                }
                item.model = result.model;
                item.fixedSpec = result.fixedSpec;
                item.modelSpec = result.modelSpec;
                item.price = result.price;
                item.ntxPrice = result.ntxPrice;
                item.taxRate = result.taxRate;
                item.wrntPeriod = result.wrntPeriod;
                item.arriveDays = result.arriveDays;
                item.goodsCatName = result.goodsCatName;
                item.goodsBrandName = result.goodsBrandName;
                item.unit = result.unit;
                item.wtxAmount = parseFloat(item.price || 0) * parseInt(item.quantity || 0);
                goodsItem.itemList = Utils.merge([], itemList);
                merchantCom.goodsItemList = Utils.merge([], goodsItemList);
                //
                let merchantComList = self.merchantComList || [];
                merchantComList[comIndex] = Utils.merge({}, merchantCom);
                self.merchantComList = Utils.merge([], merchantComList);
                // 计算含税总金额
                self.calWtxAmount(comIndex);
            });
        },
        // 是否只有组装件
        onlyForAsmblAccChange(merchantCom, comIndex, goodsIndex, onlyForAsmblAcc) {
            let goodsItemList = merchantCom.goodsItemList;
            let goodsItem = goodsItemList[goodsIndex];
            let itemList = goodsItem.itemList;
            if(Utils.isTrue(onlyForAsmblAcc)) {
                if(Utils.isTrue(goodsItem.customized)) {
                    goodsItem.quantity = 1;
                } else {
                    goodsItem.quantity = null;
                }
            }
            let asmblAccSetCount = 0;
            let asmblAccReqCount = 0;
            for(let i = 0; i < itemList.length; i++) {
                let item = itemList[i];
                if(!Utils.isNoB(item.quantity)) {
                    asmblAccSetCount = parseInt(asmblAccSetCount) + parseInt(item.quantity);
                    asmblAccReqCount = parseInt(asmblAccReqCount) + parseInt(item.reqQuantity);
                }
            }
            goodsItem.wtxAmount = parseFloat(goodsItem.price || 0) * parseInt(goodsItem.quantity || 0);
            if(!Utils.isNoB(goodsItem.reqCentBuyMode)) {
                goodsItem.centBuyMode = goodsItem.reqCentBuyMode;
            }
            goodsItem.asmblAccSetCount = asmblAccSetCount;
            goodsItem.asmblAccReqCount = asmblAccReqCount;
            merchantCom.goodsItemList = Utils.merge({}, goodsItemList);
            this.countTotalAsmblAccSetCount(merchantCom);
            //
            let merchantComList = this.merchantComList || [];
            merchantComList[comIndex] = Utils.merge({}, merchantCom);
            this.merchantComList = Utils.merge([], merchantComList);
            // 计算含税总金额
            this.calWtxAmount(comIndex);
        },
        // 数量校验
        validateQuantity: function (rule, value, callback) {
            if(Utils.isNoB(value)) {
                callback(new Error('请输入申请数量'));
            } else {
                if(!Utils.isNumber(value) || value <= 0) {
                    callback(new Error('请输入大于0的数字'));
                } else {
                    callback();
                }
            }
        },
        // 删除入选商品
        removeGoods: function (merchantCom, goodsIndex, comIndex) {
            let self = this;
            let goodsItemList = merchantCom.goodsItemList;
            let goodsItem = goodsItemList[goodsIndex];
            goodsItemList.splice(goodsIndex, 1);
            let expends = merchantCom.expends || [];
            if(expends.indexOf(goodsItem.deviceId) > -1) {
                expends.remove(goodsItem.deviceId);
            }
            merchantCom.expends = Utils.merge([], expends);
            merchantCom.goodsItemList = Utils.merge({}, goodsItemList);
            let merchantComList = this.merchantComList || [];
            merchantComList[comIndex] = Utils.merge({}, merchantCom);
            this.merchantComList = Utils.merge([], merchantComList);
            //
            this.countTotalAsmblAccSetCount(merchantCom);
            // 计算含税总金额
            this.calWtxAmount(comIndex);
        },
        // 删除入选商品的组装件
        removeAccGoods(merchantCom, comIndex, index, goodsIndex) {
            let goodsItemList = merchantCom.goodsItemList;
            let goodsItem = goodsItemList[goodsIndex];
            let itemList = goodsItem.itemList || [];
            let item = itemList[index];
            itemList.splice(index, 1);
            if(itemList.length <= 0) {
                let expends = merchantCom.expends || [];
                if(expends.indexOf(goodsItem.deviceId) > -1) {
                    expends.remove(goodsItem.deviceId);
                } else {
                    expends.push(goodsItem.deviceId);
                }
                merchantCom.expends = Utils.merge([], expends);
            }
            goodsItem.asmblAccDefCount = parseInt(goodsItem.asmblAccDefCount) - parseInt(item.setuantity);
            let asmblAccSetCount = 0;
            let asmblAccReqCount = 0;
            for(let i = 0; i < itemList.length; i++) {
                let item = itemList[i];
                if(Utils.isTrue(goodsItem.onlyForAsmblAcc)) {
                    asmblAccSetCount = parseInt(asmblAccSetCount) + parseInt(item.quantity);
                    asmblAccReqCount = parseInt(asmblAccReqCount) + parseInt(item.reqQuantity);
                } else {
                    asmblAccSetCount = parseInt(asmblAccSetCount) + parseInt(item.quantity);
                    asmblAccReqCount = parseInt(asmblAccReqCount) + parseInt(item.reqQuantity);
                }
            }
            goodsItem.asmblAccSetCount = asmblAccSetCount;
            goodsItem.asmblAccReqCount = asmblAccReqCount;
            goodsItem.itemList = Utils.merge([], itemList);
            merchantCom.goodsItemList = Utils.merge({}, goodsItemList);
            //
            this.countTotalAsmblAccSetCount(merchantCom);
            //
            let merchantComList = this.merchantComList || [];
            merchantComList[comIndex] = Utils.merge({}, merchantCom);
            this.merchantComList = Utils.merge([], merchantComList);
            // 计算含税总金额
            this.calWtxAmount(comIndex);
        },
        //
        selectServcListForBatch: function () {
            let self = this;
            let merchantComList = self.merchantComList || [];
            if(merchantComList.length <= 0) {
                MsgBox.warning('请选择机构信息');
                return;
            }
            servcInSelectDlg({checkIds: []}, function (result) {
                let itemList = result || [];
                for(let i = 0; i < merchantComList.length; i++) {
                    let merchantCom = merchantComList[i];
                    let servcItemList = merchantCom.servcItemList || [];
                    itemList.forEach(function (requireServc) {
                        let item = self.makeServcItem(requireServc);
                        //
                        servcItemList.push(item);
                    });
                    merchantCom.servcItemList = Utils.merge([], servcItemList);
                }
                self.merchantComList = Utils.merge([], merchantComList);
            });
        },
        // 选择服务
        showServcListDlg: function (merchantCom, comIndex) {
            let self = this;
            let servcItemList = merchantCom.servcItemList || [];
            let checkIds = servcItemList.pluck('servcId');
            servcInSelectDlg({checkIds: checkIds}, function (result) {
                let itemList = result || [];
                itemList.forEach(function (requireServc) {
                    let item = self.makeServcItem(requireServc);
                    //
                    servcItemList.push(item);
                });
                merchantCom.servcItemList = Utils.merge([], servcItemList);
                //
                let merchantComList = self.merchantComList || [];
                merchantComList[comIndex] = Utils.merge({}, merchantCom);
                self.merchantComList = Utils.merge([], merchantComList);
            });
        },
        makeServcItem: function (requireServc) {
            let item = {};
            item.servcId = requireServc.id;
            item.name = requireServc.name;
            item.servcCatName = requireServc.servcCatName;
            item.servcBrandName = requireServc.servcBrandName;
            item.servcBrandName = requireServc.servcBrandName;
            item.contractTitle = requireServc.contractTitle;
            item.contractDateStart = requireServc.contractDateStart;
            item.contractDateEnd = requireServc.contractDateEnd;
            item.servicerName = requireServc.servicerName;
            item.fixedSpec = requireServc.fixedSpec;
            item.title = requireServc.title;
            item.price = requireServc.price;
            item.rspTimeMi = requireServc.rspTimeMi;
            item.arriveTimeMi = requireServc.arriveTimeMi;
            item.repairedTimeMi = requireServc.repairedTimeMi;
            item.unit = '次';
            return item;
        },
        // 删除服务
        removeServc: function (merchantCom, comIndex, goodsIndex) {
            merchantCom.servcItemList.splice(goodsIndex, 1);
            //
            let merchantComList = this.merchantComList || [];
            merchantComList[comIndex] = Utils.merge({}, merchantCom);
            this.merchantComList = Utils.merge([], merchantComList);
        },
        getDlgResultMerchantComList: function () {
            let self = this;
            let result = {
                type: 'warn'
            };
            let merchantComList = self.merchantComList || [];
            if(merchantComList.length <= 0) {
                result.message = '请选择请购机构';
                return result;
            }
            let checkError = false;
            let errorMesssage = '';
            let priceErrMsg = '';
            let ntxPriceErrMsg = '';
            for(let i = 0; i < merchantComList.length; i++) {
                let merchantCom = merchantComList[i];
                // 采购商品-检查
                let quantityValid = true;
                let goodsItemList = merchantCom.goodsItemList || [];
                if((self.purchType == 3 || self.purchType == 1) && goodsItemList.length <= 0) {
                    checkError = true;
                    errorMesssage = '请选择请购商品';
                    break;
                }
                let servcItemList = merchantCom.servcItemList || [];
                if((self.purchType == 3 || self.purchType == 2) && servcItemList.length <= 0) {
                    checkError = true;
                    errorMesssage = '请选择请购服务';
                    break;
                }
                for(let i = 0; i < goodsItemList.length; i++) {
                    let goodsItem = goodsItemList[i];
                    if(!Utils.isTrue(goodsItem.onlyForAsmblAcc)) {
                        if(Utils.isNoB(goodsItem.quantity)) {
                            quantityValid = false;
                        } else {
                            if(!Utils.isNumber(goodsItem.quantity) || goodsItem.quantity <= 0) {
                                quantityValid = false;
                            }
                        }
                        goodsItem.asmblAccReqCount = goodsItem.asmblAccDefCount * goodsItem.quantity;
                    } else if(Utils.isNoB(goodsItem.itemList) || goodsItem.itemList.length <= 0) {
                        checkError = true;
                        errorMesssage = '仅组装件商品必须选择组装件信息';
                        break;
                    }
                    if(goodsItem.deviceId == null) {
                        checkError = true;
                        errorMesssage = '请确定商品信息';
                        break;
                    }
                    // 校验金额
                    if(Utils.isTrue(goodsItem.customized)) {
                        if(Utils.isNoB(goodsItem.price) || parseFloat(goodsItem.price) <= 0) {
                            priceErrMsg = '商品的含税价必须大于0';
                            break;
                        } else if(Utils.isNoB(goodsItem.ntxPrice) || parseFloat(goodsItem.ntxPrice) <= 0) {
                            ntxPriceErrMsg = '商品的未税价必须大于0';
                            break;
                        }
                    }
                }
                if(checkError) {
                    break;
                }
                if(!quantityValid) {
                    checkError = true;
                    errorMesssage = '[机构' + merchantCom.name + ']申请数量不能为空';
                    break;
                }
            }
            if(checkError) {
                result.message = errorMesssage;
                return result;
            }
            if(!Utils.isNoB(priceErrMsg)) {
                result.type = 'warn';
                result.message = priceErrMsg;
                return result;
            }
            if(!Utils.isNoB(ntxPriceErrMsg)) {
                result.type = 'warn';
                result.message = ntxPriceErrMsg;
                return result;
            }
            //
            result.type = 'info';
            result.data = {
                merchantComList: Utils.merge([], merchantComList),
                deviceRequireFileList: self.deviceRequireFileList || [],
            };
            return result;
        },
        getContractGoodsItem(vendorId, skuId, contractId, bizAreaId, bizFormId, callBack) {
            bizAreaId = Utils.isNoB(bizAreaId) ? -1 : bizAreaId;
            bizFormId = Utils.isNoB(bizAreaId) ? -1 : bizFormId;
            let postData = {
                vendorId: vendorId,
                skuId: skuId,
                bizAreaId: bizAreaId,
                bizFormId: bizFormId,
                contractId: contractId,
            };
            devcReqrApi.getContractGoodsItem(postData, function (result) {
                if(result.type == 'info') {
                    callBack(result.data);
                } else {
                    callBack(null);
                }
            })
        },
        selectCentBuyMode: function (merchantCom, comIndex, goodsIndex) {
            let goodsItemList = merchantCom.goodsItemList;
            let goodsItem = goodsItemList[goodsIndex];
            let itemList = goodsItem.itemList || [];
            itemList.forEach(function (item) {
                item.centBuyMode = goodsItem.centBuyMode;
            });
            goodsItem.itemList = Utils.merge([], itemList);
            merchantCom.goodsItemList = Utils.merge([], goodsItemList);
            //
            let merchantComList = this.merchantComList || [];
            merchantComList[comIndex] = Utils.merge({}, merchantCom);
            this.merchantComList = Utils.merge([], merchantComList);
            // 计算含税总金额
            this.calWtxAmount(comIndex);
        },
        // 添加组装件
        addAsmblAcc: function (merchantCom, comIndex, goodsIndex) {
            let self = this;
            let goodsItemList = merchantCom.goodsItemList;
            let goodsItem = goodsItemList[goodsIndex];
            let assetDefId = goodsItem.assetDefId;
            // 选择对应的组装件
            let itemList = goodsItem.itemList || [];
            let checkIds = itemList.pluck('accDefId');
            // 查询对应的组装件ids
            let devcLoading = MsgBox.loading();
            devcDefApi.getMerchtDevcAccAsmblRelAccDefIdByDevcDefId({devcDefId: assetDefId}, function (result) {
                devcLoading.close();
                if(result.type == 'info') {
                    let accDefIds = result.data || [];
                    if(accDefIds.length > 0) {
                        let params = {
                            filter: {
                                ids: accDefIds,
                            },
                            checkIds: checkIds,
                            needDisabled: true
                        };
                        // 选择组装件
                        showAsmblAccDefSelectDlg(params, function (accResult, theDlg) {
                            theDlg.close();
                            let resultData = accResult || [];
                            let ids = resultData.pluck('id');
                            // 根据组装件信息查询对应的入选商品信息
                            let postData = {
                                devcDefId: assetDefId,
                                assetDefIds: ids,
                                bizAreaId: self.bizAreaId,
                                bizFormId: self.bizFormId,
                                vendorId: goodsItem.vendorId
                            };
                            let accLoading = MsgBox.loading();
                            devcReqrApi.getRequireGoodsAsmblItemListByFilter(postData, function (rsultAcc) {
                                accLoading.close();
                                if(rsultAcc.type == 'info') {
                                    let accList = rsultAcc.data || [];
                                    if(accList.length > 0) {
                                        let quantity = 0;
                                        accList.forEach(function (item) {
                                            quantity = quantity + item.quantity;
                                            item.setQuantity = item.quantity;
                                            item.wtxAmount = (parseFloat(item.price || 0) * parseInt(item.quantity || 0)).toFixed(2);
                                        });
                                        goodsItem.asmblAccReqCount = goodsItem.asmblAccReqCount + quantity;
                                        goodsItem.asmblAccSetCount = goodsItem.asmblAccSetCount + quantity;
                                        goodsItem.itemList = Utils.merge([], itemList.concat(accList));
                                        //
                                        merchantCom.goodsItemList = Utils.merge([], goodsItemList);
                                        //
                                        let merchantComList = self.merchantComList || [];
                                        merchantComList[comIndex] = Utils.merge({}, merchantCom);
                                        self.merchantComList = Utils.merge([], merchantComList);
                                        // 计算含税总金额
                                        self.calWtxAmount(comIndex);
                                    }
                                } else {
                                    MsgBox.warning(rsultAcc.message);
                                }

                            })
                        })
                    } else {
                        MsgBox.warning('请先关联组装件');
                    }
                } else {
                    MsgBox.warning(result.message);
                }
            })
        },
        // 虚拟资产添加组装件
        addAsmblAccForVirtual: function (merchantCom, comIndex, goodsIndex) {
            let self = this;
            let goodsItemList = merchantCom.goodsItemList;
            let goodsItem = goodsItemList[goodsIndex];
            let itemList = goodsItem.itemList || [];
            //
            let itemIds = itemList.pluck('deviceId');
            let filter = {
                contractRealComId: merchantCom.realComId,
                asmblAccFlag: true,
                contractEnded: false,
                assetDefFlag: true,
                forReq: true, // 标准合同为contractRealComId 的 或 框架合同 或 无合同
                skuFlag: true, // 关联sku
            };
            if(merchantCom.bizFormId != null && merchantCom.bizFormId != -1) {
                filter.bizFormIds = [merchantCom.bizFormId, -1];
            }
            let params = {};
            params.checkIds = itemIds;
            params.filter = filter;
            goodsInSelectGroupDlg(params, function (result) {
                let adoptedDeviceList = result || [];
                adoptedDeviceList.forEach(function (adoptedDevice) {
                    let item = {};
                    item.deviceId = adoptedDevice.id;
                    item.devcTitle = adoptedDevice.devcTitle;
                    item.devcName = adoptedDevice.devcName;
                    item.devcCatName = adoptedDevice.devcCatName;
                    item.devcBrandName = adoptedDevice.devcBrandName;
                    item.devcModel = adoptedDevice.devcModel;
                    item.devcFixedSpec = adoptedDevice.devcFixedSpec;
                    item.devcUnit = adoptedDevice.devcUnit;
                    item.accDefNo = adoptedDevice.innerCode;
                    item.accDefId = adoptedDevice.assetDefId;
                    item.customized = adoptedDevice.customized;
                    item.oldCustomized = adoptedDevice.customized;
                    //
                    item.name = adoptedDevice.name;
                    item.asmblAccFlag = adoptedDevice.asmblAccFlag;
                    item.centBuyMode = adoptedDevice.centBuyMode;
                    item.reqCentBuyMode = adoptedDevice.centBuyMode;
                    item.skuId = adoptedDevice.skuId;
                    item.title = adoptedDevice.title;
                    item.bizAreaCode = adoptedDevice.bizAreaCode;
                    item.bizFormCode = adoptedDevice.bizFormCode;
                    item.vendorName = adoptedDevice.vendorName;
                    item.vendorRealComId = adoptedDevice.vendorRealComId;
                    item.vendorRealComName = adoptedDevice.vendorRealComName;
                    item.vendorRealComCode = adoptedDevice.vendorRealComCode;
                    item.vendorId = adoptedDevice.vendorId;
                    if(Utils.isTrue(adoptedDevice.contractEnded)) {
                        item.contractId = -1;
                    } else {
                        item.contractTitle = adoptedDevice.contractTitle;
                        item.contractId = adoptedDevice.contractId;
                        item.contractDateStart = adoptedDevice.contractDateStart;
                        item.contractDateEnd = adoptedDevice.contractDateEnd;
                    }
                    item.model = adoptedDevice.model;
                    item.fixedSpec = adoptedDevice.fixedSpec;
                    item.modelSpec = adoptedDevice.modelSpec;
                    item.price = adoptedDevice.price;
                    item.oldPrice = adoptedDevice.price;
                    item.ntxPrice = adoptedDevice.ntxPrice;
                    item.taxRate = adoptedDevice.taxRate;
                    item.wrntPeriod = adoptedDevice.wrntPeriod;
                    item.arriveDays = adoptedDevice.arriveDays;
                    item.goodsCatName = adoptedDevice.goodsCatName;
                    item.goodsBrandName = adoptedDevice.goodsBrandName;
                    item.unit = adoptedDevice.unit;
                    item.quantity = 1;
                    item.wtxAmount = parseFloat(item.price || 0) * parseInt(item.quantity || 0);
                    //
                    if(itemIds.indexOf(item.deviceId) < 0) {
                        itemList.push(item);
                    }
                });
                goodsItemList[goodsIndex].itemList = Utils.merge([], itemList);
                merchantCom.goodsItemList = Utils.merge([], goodsItemList);
                //
                let merchantComList = self.merchantComList || [];
                merchantComList[comIndex] = Utils.merge({}, merchantCom);
                self.merchantComList = Utils.merge([], merchantComList);
                // 计算含税总金额
                self.calWtxAmount(comIndex);
            });
        },

        // 附件移除
        deleteFile: function (event) {
            let trackKey = event.trackKey;
            //
            let deviceRequireFileList = this.deviceRequireFileList || [];
            deviceRequireFileList.removeAt(trackKey);
            this.deviceRequireFileList = Utils.merge([], deviceRequireFileList);
            return false;
        },
        // 上传附件信息
        showDialogFile: function () {
            let self = this;
            let deviceRequireFileList = self.deviceRequireFileList || [];
            let theDlg = Vue.$showDialog({
                title: '采购附件上传',
                width: 500,
                height: 200,
                showCloseBtn: true,
                okVisible: false,
                template: '<swb-file-upload-list :selectFileUuids="selectFileUuids" @handle-change="getSelectFileList" ref="swb_file_upload_list"></swb-file-upload-list>',
                data: {
                    selectFileUuids: deviceRequireFileList.pluck('fileUuid'),
                },
                okClicked: function () {
                    let result = this.$refs.swb_file_upload_list.getFilesResult() || {};
                    if(result.type === 'info') {
                        let resultData = result.data || {};
                        //
                        let selectFileList = resultData.selectFileList || [];
                        self.deviceRequireFileList = Utils.merge([], selectFileList);
                        //
                        return true;
                    }
                    return false;
                },
                methods: {
                    getSelectFileList: function (selectFileList) {
                        let fileNames = selectFileList.pluck('name') || [];
                        let warnFlag = false;
                        let message = '';
                        for(let i = 0; i < deviceRequireFileList.length; i++) {
                            let fileInfo = deviceRequireFileList[i];
                            if(fileNames.indexOf(fileInfo.name) >= 0) {
                                warnFlag = true;
                                message = '文件名称[' + fileInfo.name + ']存在重复名称';
                                break;
                            }
                        }
                        if(warnFlag) {
                            MsgBox.warning(message);
                            return;
                        }
                        self.deviceRequireFileList = deviceRequireFileList.concat(selectFileList);
                        theDlg.close();
                    }
                },
            });
        },
        // 下载导入模板
        generalImport: function () {
            let self = this;
            let uploadParams = {
                title: '请购商品导入',
                fileGroup: 'device.require.import',
                multipleFile: false
            };
            fileUploadGroupShowDlg(uploadParams, '/api/devcReqr/device/require/voucher/download', function (result, theDlg) {
                theDlg.close();
                if(result.type === 'info') {
                    let files = result.data.files;
                    self.file = files[0];
                    // 文件是否按模版导入
                    let errorMsgList = self.file.extra.errorMsgList;
                    if(!Utils.isNoB(errorMsgList) && errorMsgList.length > 0) {
                        MsgBox.warning(errorMsgList.join('<br/>'));
                        return;
                    }
                    //
                    let impInfo = self.file.extra.impInfo || [];
                    let theLoad = MsgBox.loading();
                    devcReqrApi.doInvalidDeviceRequireVoucher(impInfo, function (result) {
                        if(result.type == 'info') {
                            let merchantComList = result.data || [];
                            for(let i = 0; i < merchantComList.length; i++) {
                                let merchantCom = merchantComList[i];
                                merchantCom.id = merchantCom.comId;
                                merchantCom.name = merchantCom.comName;
                                //
                                let deviceIds = [];
                                let itemList = merchantCom.adoptedDeviceList || [];
                                let goodsItemList = [];
                                //
                                itemList.forEach(function (deviceRequirer) {
                                    let item = self.makeGoodsItem(deviceRequirer);
                                    //
                                    goodsItemList.push(item);
                                    deviceIds.push(deviceRequirer.id);
                                });
                                // 计算含税总金额
                                let wtxAmount = 0;
                                for(let i = 0, len = goodsItemList.length; i < len; i++) {
                                    let goodsItemInfo = goodsItemList[i];
                                    wtxAmount += parseFloat(goodsItemInfo.wtxAmount || 0);
                                }
                                merchantCom.wtxAmount = wtxAmount;
                                merchantCom.adoptedDeviceList = null;
                                merchantCom.goodsItemList = Utils.merge([], goodsItemList);
                                self.getAccDefList(merchantCom, i, deviceIds);
                            }
                            self.merchantComList = Utils.merge([], merchantComList)
                        } else {
                            MsgBox.warning(result.message);
                        }
                        theLoad.hide();
                    });
                } else {
                    MsgBox.warning(result.message);
                }
            });
        },
        // 返回是否显示提交按钮
        getSubmitAvaliable: function () {
            let self = this;
            let merchantComList = this.merchantComList || [];
            let submitAvaliable = true;
            let allItemList = [];
            for(let i = 0; i < merchantComList.length; i++) {
                let merchantCom = merchantComList[i];
                let itemList = merchantCom.goodsItemList || [];
                allItemList = allItemList.concat(itemList);
            }
            let hasJC = false; // 有集采
            let hasZC = false; // 有自采
            for(let i = 0; i < allItemList.length; i++) {
                let itemInfo = allItemList[i];
                if(Utils.isTrue(hasJC) && Utils.isTrue(hasZC)) {
                    break;
                }
                if(Utils.isTrue(itemInfo.centBuyMode)) {
                    // 集采
                    hasJC = true;
                } else {
                    // 自采
                    hasZC = true;
                }
            }
            if(Utils.isTrue(hasJC) && Utils.isTrue(hasZC)) {
                submitAvaliable = false;
            } else {
                submitAvaliable = true;
            }
            return submitAvaliable;
        }
    }
}
</script>
<style>
.el-table .row-expand-cover .cell .el-table__expand-icon {
    display: none;
}

div.file-area {
    display: inline-block;
    margin-top: 0;
}

.file-area > div.file-item {
    width: 64px;
    height: 64px;
    line-height: 64px;
}
</style>



// WEBPACK FOOTER //
// src/compo/retailer/CreateRequireItemForBatch.vue